import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { CustomOrderEntry, CustomOrderEntryWithDelivery } from '@cart/const';
import { OrderService } from '@order/feature';
import { TrackingPickupSchemeComponent } from '@sdvor/tracking/ui';
import { PromotionLocation } from '@spartacus/core';
import { ModalService } from '@spartacus/storefront';
import { combineLatest, filter, map, Observable, tap } from 'rxjs';
import { OrderDetailsComponentService } from '../order-details.component-service';

@Component({
  selector: 'sd-order-details-items',
  templateUrl: './order-detail-items.component.html',
  styleUrls: ['./order-detail-items.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdCustomOrderDetailItemsComponent implements OnDestroy, OnInit {
  showDeliverySwitch$: Observable<boolean>;
  filteredEntries$: Observable<CustomOrderEntryWithDelivery[] | undefined>;
  orderEntries$: Observable<CustomOrderEntry[] | undefined>;
  promotionLocation: PromotionLocation = PromotionLocation.Order;

  constructor(
    private orderService: OrderService,
    private orderDetailsComponentService: OrderDetailsComponentService,
    private modalService: ModalService,
  ) {}

  ngOnInit(): void {
    this.orderEntries$ = this.orderDetailsComponentService.orderEntries$.pipe(
      filter(Boolean),
      tap((entries) => {
        const entriesWithDelivery = [];
        const entriesWithPickup = [];

        entries?.forEach((entry) => {
          if (entry.pickup) {
            entriesWithPickup.push(entry);
          }
          if (entry.delivery) {
            entriesWithDelivery.push(entry);
          }
        });

        // Смотрю, какие типы доставок пришли, если только один тип есть - то свич не показываем.
        // ShowDeliverySwitch - отвечает за показ/ не показ свича

        this.orderDetailsComponentService.setShowDeliverySwitch(
          !(entriesWithDelivery.length === 0 || entriesWithPickup.length === 0),
        );

        // Если нет товаров с delivery, то меняем свич на самовывоз

        this.orderDetailsComponentService.setDeliveryFilter(entriesWithDelivery.length > 0 ? true : false);
      }),
    );

    this.showDeliverySwitch$ = this.orderDetailsComponentService.getShowDeliverySwitch();

    this.filteredEntries$ = this.getFilteredEntries();
  }

  getFilteredEntries(): Observable<CustomOrderEntryWithDelivery[]> {
    return combineLatest({
      entries: this.orderEntries$,
      isDelivery: this.orderDetailsComponentService.getDeliveryFilter(),
    }).pipe(
      map(({ entries, isDelivery }) => {
        if (!entries) return [];

        // Сортируем, в зависимости от свича
        const filteredEntries = isDelivery
          ? entries.filter((entry) => entry.delivery)
          : entries.filter((entry) => entry.pickup);

        return this.orderDetailsComponentService.mapOrderEntriesToGroups(filteredEntries);
      }),
    );
  }

  openScheme(scheme: string, orderEntries: CustomOrderEntry[]): void {
    const modalRef = this.modalService.open(TrackingPickupSchemeComponent, {
      centered: true,
      size: 'xl',
      windowClass: 'pickup-tracking-scheme',
    });

    modalRef.componentInstance.scheme = scheme;
    modalRef.componentInstance.orderEntries = orderEntries;
  }

  ngOnDestroy(): void {
    this.orderService.clearOrderDetails();
  }
}
